<template>
	<div ref="weekBarBox" id="weekBarBox" class="weekBarBox">
		<div id="weekBar" style="height: 370px; width: 100%"></div>
	</div>
</template>

<script>
import * as echarts from 'echarts'

export default {
    name: 'cl-eval-bar',
    props: {
        allEvalList: {
            type: Array,
            default: () => ([])
        }
    },

    data() {
        return {
            changeIndex: 0,
            myChart: null,
        }
    },

    watch: {
        'allEvalList': {
            handler(newV) {
                this.weekBarData(newV);
            }
        }
    },

    methods: {
        //柱状图
        async weekBarData(data) {
            if (!data.length) {
                return
            }
            const that = this;
            if (that.myChart) {
                that.myChart.dispose();
            }
            await this.$nextTick();
            this.changeIndex = this.allEvalList.length - 1
            // 指定图表的配置项和数据
            const weekBar = document.getElementById('weekBar');
            that.myChart = this.$echarts.init(weekBar);
            //动态设置echarts宽度 大于10
            let boxWidth = document.getElementsByClassName('barData')[0].clientWidth;
            if (data.length > 10) {
                weekBar.style.width = 'calc(' + boxWidth + 'px + ' + '80' * (data.length - 10) + 'px)'
                that.myChart.resize();
            } else {
                weekBar.style.width = parseInt((boxWidth * 0.95).toString()) - 1 + 'px'
                that.myChart.resize()
            }
            let labelOption = {
                show: true,
                position: 'top',
                rotate: '0',
                align: 'center',
                verticalAlign: 'middle',
                distance: '15',
                formatter: value => {
                    if (value.dataIndex == this.changeIndex) {
                        return '{nowNum0|' + value.data.value + '}'
                    } else {
                        return '{allNum|' + value.data.value + '}'
                    }
                },
                rich: {
                    nowNum0: {
                        color: '#FFB23E',
                        fontFamily: 'SysFontM',
                        fontSize: 12,
                    },
                    allNum: {
                        color: '#787885',
                        fontFamily: 'SysFontM',
                        fontSize: 12,
                    },
                },
            }
            that.myChart.setOption({
                grid: {
                    top: '80',
                    left: '20',
                    right: '20',
                    bottom: '7%',
                    containLabel: true,
                },
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        // 坐标轴指示器，坐标轴触发有效
                        type: 'shadow', // 默认为直线，可选为：'line' | 'shadow'
                        shadowStyle: '#FAFAFA',
                    },
                    textStyle: {
                        fontFamily: 'SysFontM',
                        align: 'left',
                    },
                    formatter: (params) => {
                        let html = `<div>${params[0].name}</div>`
                        params.forEach((item) => {
                            html += `<div style='display: flex;align-items: center;justify-content: space-between;'>
                                        <span class="SysFontM" >${item.data.value}</span>
                                    </div>`
                        })
                        return html
                    },
                },
                //  ------  X轴 ------
                xAxis: {
                    show: true, // 是否显示
                    nameGap: 15, // 坐标轴名称与轴线之间的距离
                    axisLabel: {
                        // 坐标轴标签
                        show: true, // 是否显示
                        color: '#F2F7FA', // 默认取轴线的颜色
                        interval: 0,
                        formatter: (value, index) => {
                            if (index == this.changeIndex) {
                                return '{now|' + value + '}'
                            } else {
                                return '{all|' + value + '}'
                            }
                        },
                        rich: {
                            now: {
                                color: '#3A3A3A',
                                fontSize: '12',
                                fontFamily: 'SysFontM',
                                lineHeight: 22,
                            },
                            all: {
                                color: '#787885',
                                fontSize: '12',
                                fontFamily: 'SysFontM',
                                lineHeight: 22,
                            },
                        },
                    },
                    type: 'category',
                    interval: 0,
                    axisLine: {
                        show: false,
                    },
                    axisTick: {
                        show: false,
                    },
                    data: data.map(item => item.date),
                },
                //   ------   y轴  ----------
                yAxis: {
                    show: true, // 是否显示
                    nameTextStyle: {
                        // 坐标轴名称样式
                        color: '#F2F7FA',
                        padding: [5, 0, 0, 5], // 坐标轴名称相对位置
                    },
                    nameGap: 15, // 坐标轴名称与轴线之间的距离
                    axisLabel: {
                        show: true,
                        textStyle: {
                            color: '#787885',
                            fontSize: 12,
                            fontFamily: 'SysFontM',
                        },
                    },
                    axisLine: {
                        show: false,
                    },
                    splitLine: {
                        lineStyle: {
                            type: 'dashed',
                            color: ['#F2F7FA'],
                        },
                        show: true,
                    },
                    axisTick: {
                        show: false,
                    },
                },
                series: {
                    type: 'bar', // 类型
                    itemStyle: {
                        // 图形的形状
                        normal: {
                            //柱形图圆角，初始化效果
                            barBorderRadius: [3, 3, 0, 0],
                            color: (params) => {
                                if (this.changeIndex == params.dataIndex) {
                                    return new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                                        { offset: 0, color: '#5A81ED' }, //柱图渐变色
                                        { offset: 1, color: '#3663E1'},
                                    ])
                                } else {
                                    return '#E1E1E3'
                                }
                            },
                            label: labelOption, //图形上的文本标签
                        },
                    },
                    // 鼠标悬停时：
                    emphasis: {
                        //柱形图圆角，初始化效果
                        barBorderRadius: [3, 3, 0, 0],
                        itemStyle: {
                            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                                { offset: 0, color: '#5A81ED' }, //柱图渐变色
                                { offset: 1, color: '#3663E1'},
                            ]),
                        },
                    },
                    barWidth: 15, // 柱形的宽度
                    barGap: 0.4,
                    data: data.map(item => {
                        return {
                            id: item.id,
                            value: item.totalScore || item.data || item.total_score,
                        }
                    }),
                },
            })
        
            that.myChart.dispatchAction({
                type: 'highlight',
                // 使用 dataIndex 来定位节点。
                seriesIndex: '',
                dataIndex: this.changeIndex,
            })
            
            that.myChart.on('click', params => {
                //先取消高亮
                that.myChart.dispatchAction({
                    type: 'downplay',
                    // 使用 name 来定位节点。
                    seriesIndex: '',
                    dataIndex: params.dataIndex,
                })
                that.myChart.dispatchAction({
                    type: 'highlight',
                    seriesIndex: '',
                    // 使用 dataIndex 来定位节点。
                    dataIndex: params.dataIndex,
                })
                this.changeIndex = params.dataIndex
                if (params.data.id) {
                    this.$emit('bar-click', params.data.id);
                }
                that.myChart.setOption({
                    xAxis: [
                        {
                            axisLabel: {
                                color: (value, index) => {
                                    return index == this.changeIndex ? '#3A3A3A' : '#787885'
                                },
                                fontSize: 12,
                                fontFamily: (value, index) => {
                                    return index == this.changeIndex ? 'SysFontM' : 'SysFontM'
                                },
                            },
                        },
                    ],
                })
            })
            that.myChart.resize()
            window.addEventListener('resize', function () {
                that.myChart.resize()
            })
        }
    }

}

</script>

<style scoped lang="scss">
    .barData {
        width: 100%;
        overflow-x: auto;
        box-sizing: border-box;
        .weekBarBox {
            width: 100%;
            height: 370px;
        }
    }
</style>
